module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/book/book-sync/book-sync.component.scss
// module id = ./src/app/book/book-sync/book-sync.component.scss
// module chunks = main